import { tabsAnatomy as parts } from '@chakra-ui/anatomy'
import { mode } from '@chakra-ui/theme-tools'

const baseStyleRoot = props => {
  const { orientation } = props
  return {
    display: orientation === 'vertical' ? 'flex' : 'block'
  }
}

const baseStyleTab = props => {
  const { isFitted } = props

  return {
    flex: isFitted ? 1 : undefined,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  }
}

const baseStyleTablist = props => {
  const { align = 'start', orientation } = props

  const alignments = {
    end: 'flex-end',
    center: 'center',
    start: 'flex-start'
  }

  return {
    mt: 2,
    justifyContent: alignments[align],
    flexDirection: orientation === 'vertical' ? 'column' : 'row'
  }
}

const baseStyleTabpanel = {
  pt: 4,
  pb: 0,
  px: 0,
  borderTopWidth: '1px'
}

const baseStyle = props => ({
  root: baseStyleRoot(props),
  tab: baseStyleTab(props),
  tablist: baseStyleTablist(props),
  tabpanel: baseStyleTabpanel
})

const variantLine = props => {
  const { orientation } = props
  const isVertical = orientation === 'vertical'
  const borderProp = orientation === 'vertical' ? 'borderStart' : 'borderBottom'
  const marginProp = isVertical ? 'marginStart' : 'marginBottom'

  return {
    tablist: {
      display: 'inline-flex',
      borderColor: 'transparent',
      borderBottomWidth: 0
    },
    tab: {
      fontWeight: 'semibold',
      color: 'brand.muted',
      [borderProp]: '2px solid',
      borderColor: 'transparent',
      [marginProp]: '-2px',
      _selected: {
        color: 'brand.main',
        borderColor: 'currentColor'
      },
      _active: {
        bg: mode('gray.200', 'whiteAlpha.300')(props)
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      }
    }
  }
}

const variants = {
  line: variantLine,
  unstyled: {}
}

export const Tabs = {
  parts: parts.keys,
  baseStyle,
  sizes: {
    sm: {
      tab: {
        py: 2,
        px: 4,
        fontSize: 'sm'
      }
    },
    md: {
      tab: {
        fontSize: 'md',
        py: 3,
        px: 4
      }
    },
    lg: {
      tab: {
        fontSize: 'lg',
        py: 4,
        px: 6
      }
    }
  },
  variants,
  defaultProps: {
    size: 'sm',
    variant: 'line'
  }
}
